import { useContext } from "react";
import { GlobalContext } from "GlobalContext";
import { useTranslation } from "react-i18next";
import { EditEmployee as EditingEmployee } from "utils/Employees";
import { useEmployeeForm } from "./hooks/useEmployeeForm";
import { EmployeeFormDialog } from "./EmployeeFormDialog";

interface EditEmployeeProps {
	data: Employee;
	open: boolean;
	setOpen: (open: boolean) => void;
	reloading: () => void;
	rows: Employee[];
}

const EditEmployee = ({ data, open, setOpen, reloading, rows }: EditEmployeeProps) => {
	const { t } = useTranslation();
	const { handlerAlert } = useContext(GlobalContext);

	const form = useEmployeeForm({ open, setOpen, initialData: data, rows });

	const handleSubmit = () => {
		const { birthDate, getBody, setLoadingSubmit } = form;
		// document_type_id hardcoded to 1 para preservar el comportamiento original
		const body = {
			...getBody(birthDate!.format("YYYY-MM-DD")),
			document_type_id: 1,
		};
		EditingEmployee(
			setLoadingSubmit,
			data.employee_id,
			body,
			() => form.closing(true),
			reloading,
			handlerAlert,
			t
		);
	};

	return (
		<EmployeeFormDialog
			open={open}
			title="timekeeper.employees.dialog.edit.title"
			submitLabel="settings.paycodes.table.modals.add.buttons.save"
			form={form}
			onSubmit={handleSubmit}
		/>
	);
};

export { EditEmployee };
